import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Rss"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 18H22.5C22.5 8.925 15.075 1.5 6 1.5V3C14.25 3 21 9.75 21 18ZM15 18H16.5C16.5 12.225 11.775 7.5 6 7.5V9C10.95 9 15 13.05 15 18ZM1.5 18C1.5 15.525 3.525 13.5 6 13.5C8.475 13.5 10.5 15.525 10.5 18C10.5 20.475 8.475 22.5 6 22.5C3.525 22.5 1.5 20.475 1.5 18ZM6 21C4.35 21 3 19.65 3 18C3 16.35 4.35 15 6 15C7.65 15 9 16.35 9 18C9 19.65 7.65 21 6 21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Rss.vue"]]);
